import { Globe, ChevronRight } from "lucide-react";

const MapTab = ({ communityStats, alumni }) => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl p-5 border border-stone-100">
        <h3 className="font-serif text-lg text-[#1A1A1A] mb-2">Savi Global Community 🌍</h3>
        <p className="text-sm text-[#1A1A1A]/60 mb-4">Guests from around the world</p>
        
        {/* Nationalities display */}
        {communityStats?.nationalities && Object.keys(communityStats.nationalities).length > 0 ? (
          <div className="bg-gradient-to-br from-[#8C9A7C]/20 to-[#C85A38]/10 rounded-2xl p-4 mb-4">
            <p className="text-sm font-medium text-[#1A1A1A] mb-3">Where our guests come from:</p>
            <div className="flex flex-wrap gap-2">
              {Object.entries(communityStats.nationalities).map(([country, count]) => (
                <div 
                  key={country}
                  className="bg-white rounded-full px-3 py-1.5 flex items-center gap-2 shadow-sm"
                >
                  <span className="text-sm">{country}</span>
                  <span className="text-xs bg-[#C85A38] text-white rounded-full px-2 py-0.5">
                    {count}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="aspect-video bg-gradient-to-br from-[#8C9A7C]/30 to-[#C85A38]/20 rounded-2xl flex items-center justify-center">
            <div className="text-center">
              <Globe className="w-12 h-12 text-[#1A1A1A]/30 mx-auto mb-2" />
              <p className="text-sm text-[#1A1A1A]/50">Nationality data coming soon</p>
            </div>
          </div>
        )}
        
        {/* Country stats */}
        <div className="mt-4 grid grid-cols-3 gap-2">
          <div className="bg-[#F0EDE3] rounded-xl p-3 text-center">
            <p className="text-2xl font-bold text-[#1A1A1A]">
              {communityStats?.total_countries || 0}
            </p>
            <p className="text-xs text-[#1A1A1A]/60">Countries</p>
          </div>
          <div className="bg-[#F0EDE3] rounded-xl p-3 text-center">
            <p className="text-2xl font-bold text-[#1A1A1A]">
              {communityStats?.total_alumni || 0}
            </p>
            <p className="text-xs text-[#1A1A1A]/60">Alumni</p>
          </div>
          <div className="bg-[#F0EDE3] rounded-xl p-3 text-center">
            <p className="text-2xl font-bold text-[#1A1A1A]">
              {communityStats?.current_guests || 0}
            </p>
            <p className="text-xs text-[#1A1A1A]/60">Current</p>
          </div>
        </div>
      </div>

      {/* Alumni Section */}
      <div className="bg-[#1A1A1A] rounded-xl p-5 text-white">
        <h3 className="font-serif text-lg mb-4">Savi Alumni Network</h3>
        <p className="text-white/70 text-sm mb-4">
          Once a Savi guest, always part of the family. {alumni.length > 0 ? `${alumni.length} past guests and counting!` : "Connect with past guests around the world."}
        </p>
        
        {alumni.length > 0 && (
          <div className="grid grid-cols-4 gap-2 mb-4">
            {alumni.slice(0, 8).map((alum, idx) => (
              <div key={idx} className="text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-white/20 flex items-center justify-center overflow-hidden">
                  {alum.avatar ? (
                    <img src={alum.avatar} alt={alum.name} className="w-full h-full object-cover" />
                  ) : (
                    <span className="text-white font-medium">{alum.name?.charAt(0)}</span>
                  )}
                </div>
                <p className="text-xs text-white/70 mt-1 truncate">{alum.name}</p>
              </div>
            ))}
          </div>
        )}
        
        <button 
          className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-sm hover:bg-white/30 transition-colors"
        >
          Explore Network <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MapTab;
